import {action, observable} from 'mobx'

import CatalogEntity from './CatalogEntity'

import * as ProfileCatalogSelectionMode from '../../constant/ProfileCatalogSelectionMode'
import * as Type from '../../constant/ProfileCatalogEntityType'

export default class CatalogSelection {
    @observable selection_mode
    /** @type {Array<CatalogEntity>} */
    @observable catalog_selection_entities_union = []

    constructor(selection_mode, catalog_selection_entities_union) {
        this.selection_mode = selection_mode
        this.catalog_selection_entities_union = catalog_selection_entities_union.map(a => new CatalogEntity(a))
    }

    @action setSelectionMode(selection_mode) {
        this.selection_mode = selection_mode

        if (this.selection_mode === ProfileCatalogSelectionMode.FULL_CATALOG) {
            this.catalog_selection_entities_union = []
        }

        if (this.selection_mode === ProfileCatalogSelectionMode.SELECTED_ENTITIES) {
            this.catalog_selection_entities_union = [new CatalogEntity()]
        }
    }

    @action addNewEntity(with_categories, with_sets, with_product_types) {
        const available_types = this.getAvailableEntityTypes(null, with_categories, with_sets, with_product_types)

        if (available_types.length === 0) {
            return
        }

        const new_entity = new CatalogEntity()
        new_entity.type = available_types[0]

        this.catalog_selection_entities_union.push(new_entity)
    }

    @action removeEntityByType(entity_type) {
        this.catalog_selection_entities_union = this.catalog_selection_entities_union.filter(e => e.type !== entity_type)
    }

    getAvailableEntityTypes(with_type, with_categories, with_sets, with_product_types) {
        const selected = {}
        this.catalog_selection_entities_union.forEach(e => selected[e.type] = true)

        return Type.all_types
            .filter(type =>
                (type === with_type || !selected.hasOwnProperty(type))
                && (type !== Type.CATEGORY || with_categories)
                && (type !== Type.PRODUCTS_SET || with_sets)
                && (type !== Type.PRODUCTS_TYPE || with_product_types)
            )
    }

    getAvailableEntityTypeOptions(with_type, with_categories, with_sets, with_product_types) {
        return this.getAvailableEntityTypes(with_type, with_categories, with_sets, with_product_types).map(type => ({
            label: Type.label[type],
            value: type,
        }))
    }
}
